import React from 'react'
import { Alert, } from 'reactstrap'

export default function ErrorMessages({errors}) {

  let errorsListItems = []
  errors.forEach((error, n) => {
    errorsListItems.push(
      <li key={`error${n}`}>{error}</li>
    )
  })


  if (errorsListItems === []) {
    errorsListItems = null
  }

  return (
    <Alert color='danger'>
      <p>Please correct these errors in your file, then re-upload.</p>
      <ul>
        {errorsListItems}
      </ul>
    </Alert>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/ImportUsers/ErrorMessages.js